import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      label: 'LinkedIn',
      icon: <FaLinkedin size={22} />,
      href: 'https://www.linkedin.com/in/ajitcpatil/',
    },
    {
      id: 2,
      label: 'GitHub',
      icon: <FaGithub size={22} />,
      href: 'https://github.com/ajitp4292',
    },
    {
      id: 3,
      label: 'Email',
      icon: <HiOutlineMail size={23} />,
      href: 'mailto:ajitcpatil42@gmail.com',
    },
    {
      id: 4,
      label: 'Resume',
      icon: <BsFillPersonLinesFill size={22} />,
      href: '/Resume_Ajit_Patil.pdf',
    },
  ];

  return (
    <div className="hidden lg:flex fixed left-5 bottom-8 z-40 flex-col gap-3">
      {links.map(({ id, label, icon, href }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          title={label}
          className="w-11 h-11 rounded-full border border-white/10 bg-black/70 backdrop-blur-md text-gray-300 flex items-center justify-center transition hover:-translate-y-1 hover:text-cyan-300 hover:border-cyan-400/40"
        >
          {icon}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
